import Layout from "../../components/Layout.tsx";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/Table.tsx";
import { useState } from "react";
import { Select } from "../../components/Select.tsx";
import { Text } from "../../components/Text.tsx";
import { StepProps } from "./AddNewConnection.tsx";
import { useNewConnectionContext } from "../../context/NewConnectionContext.tsx";
import { useApplicationInfoContext } from "../../context/ApplicationInfoContext.tsx";

const MapAdministrationsStep = ({
  handleButtonBackClick,
  handleButtonNextClick,
  stepIndicator,
}: StepProps) => {

  const { newConnectionData, dispatch } = useNewConnectionContext()
  const { applicationInfo } = useApplicationInfoContext();

  const easyflexAdministraties = applicationInfo.availableEasyFlexAdmins;
  const exactAdministraties = applicationInfo.availableDestinations;

  // Use existing values from context if available, otherwise default to first available
  const [selectedEasyflexAdministratie, setSelectedEasyflexAdministratie] = useState(
    newConnectionData.sourceAdministrationId > 0
      ? newConnectionData.sourceAdministrationId
      : easyflexAdministraties[0]?.id || 0
  );
  const [selectedExactOnlineAdministratie, setSelectedExactOnlineAdministratie] = useState(
    newConnectionData.destinationAdministrationId > 0
      ? newConnectionData.destinationAdministrationId
      : exactAdministraties[0]?.id || 0
  );


  const onButtonNextClick = () => {
    if (!selectedEasyflexAdministratie) {
      alert("Configureer eerst een Easyflex API sleutel voor een administratie");
      return;
    }
    if (!selectedExactOnlineAdministratie) {
      alert("Selecteer een Exact Online-administratie");
      return;
    }

    dispatch({ type: "UPDATE_FIELD", key: "sourceAdministrationId", value: selectedEasyflexAdministratie });
    dispatch({ type: "UPDATE_FIELD", key: "destinationAdministrationId", value: selectedExactOnlineAdministratie });

    handleButtonNextClick?.();
  }

  const isUpdating = newConnectionData.id && newConnectionData.id > 0;

  return (
    <Layout
      title={isUpdating ? "Koppeling aanpassen" : "Nieuwe koppeling maken"}
      stepTitle="Administraties koppelen"
      onButtonBackClick={handleButtonBackClick}
      onButtonNextClick={onButtonNextClick}
      stepIndicator={stepIndicator}
    >
      <Text className="mb-12">
        Selecteer één Easyflex-administratie om te koppelen aan een
        administratie van je financiële systeem.
      </Text>
      <Table dense>
        <TableHead>
          <TableRow>
            <TableHeader>Easyflex administratie</TableHeader>
            <TableHeader>Exact Online administratie</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Select name="easyflexAdministratie"
                onChange={(e) => setSelectedEasyflexAdministratie(parseInt(e.target.value))}
                value={selectedEasyflexAdministratie}
              >
                <option value={0} disabled>
                  {easyflexAdministraties.length
                    ? "Selecteer één administratie"
                    : "Geen administratie met API sleutel gevonden"}
                </option>
                {easyflexAdministraties.map((easyflexAdministratie) => (
                  <option key={easyflexAdministratie.id} value={easyflexAdministratie.id}>
                    {easyflexAdministratie.name} {easyflexAdministratie.id}
                  </option>
                ))}
              </Select>
            </TableCell>
            <TableCell>
              <Select name="exactAdministratie"
                value={selectedExactOnlineAdministratie}
                onChange={(e) => setSelectedExactOnlineAdministratie(parseInt(e.target.value))}
              >
                <option value={0} disabled>
                  Selecteer één administratie
                </option>
                {exactAdministraties.map((exactAdministratie) => {
                  return (
                    <option key={exactAdministratie.id} value={exactAdministratie.id}>
                      {exactAdministratie.name} {exactAdministratie.id}
                    </option>
                  );
                })}
              </Select>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Layout>
  );
};

export default MapAdministrationsStep;
